import { uniqueId } from 'lodash';
import { AdminBundle, LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';

import { BundleTranslationWithKey, AdminBundleItemWithKey } from './types';

export const getInitialAdminBundle = (): AdminBundle => ({
  id: 0,
  name: '',
  finance_id: '',
  description: '',
  main_item_option_ids: [],
  items: [],
  prices: [],
});

export const getInitialBundleTranslation = (localeId: LocaleResponse['id']): BundleTranslationWithKey => ({
  id: 0,
  key: uniqueId(),
  description: '',
  locale_id: localeId,
  name: '',
});

export const createAdminBundleItem = (
  name: string,
  options: number[],
  translations: { name: string; localeId: number }[],
): AdminBundleItemWithKey => ({
  id: 0,
  key: uniqueId(),
  name,
  options,
  translations: translations.map(translation => ({ id: 0, name: translation.name, locale_id: translation.localeId })),
});
